<template>
    <div class="na-form">
        <div v-if="appObjectDetail" class="left">

            <DxTabPanel>
                <DxItem :title="tx.TabBasicData">

                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">Id:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='appObjectDetail.ObjId' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldName}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='appObjectDetail.ObjName' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldDesc}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='appObjectDetail.ObjDescription' />
                            </div>

                        </div>


                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldAlias}}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='appObjectDetail.ObjAlias' />
                            </div>

                        </div><div class="dx-field">
                                  <div class="dx-field-label">{{tx.FieldVisible}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='appObjectDetail.ObjHasAccessRights' />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem :title="tx.TabRights">
                    <DxDataGrid :data-source="accessList"
                                :key-expr="GrpId"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxColumn data-field="ObjName"
                                  :allow-editing="false"
                                  :sort-index="0"
                                  :caption="column.ColAccObj"
                                  data-type="string" />
                        <DxColumn data-field="CanRead"
                                  :caption="column.ColRead"
                                  data-type="boolean" />
                        <DxColumn data-field="CanUpdate"
                                  :caption="column.ColEdit"
                                  data-type="boolean" />
                        <DxColumn data-field="CanInsert"
                                  :caption="column.ColCreate"
                                  data-type="boolean" />
                        <DxColumn data-field="CanDelete"
                                  :caption="column.ColDelete"
                                  data-type="boolean" />
                        <DxColumn data-field="CanInlineEdit"
                                  :caption="column.ColInlineEdit"
                                  data-type="boolean" />
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :text="btn.BtnSave"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick()" />
                </div>
                <div>
                    <DxButton :text="btn.BtnDelete"
                              type="default"
                              styling-mode="contained"
                              @click="onDeleteClick()" />
                </div>
                <div>
                    <DxButton :text="btn.BtnCancel"
                              type="default"
                              styling-mode="outlined"
                              @click="onCloseClick()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    import { DxDataGrid, DxColumn, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid';
    import { DxTextBox, DxTextArea } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import '../assets/detailForm.less';
    import { confirm, alert } from "devextreme/ui/dialog";
    import $ from 'jquery';
    import { DxTabPanel } from 'devextreme-vue/tab-panel';
    import { DxItem } from 'devextreme-vue/html-editor';
    import { DxCheckBox } from 'devextreme-vue/check-box';

    const baseUri = "WebApi.asmx/api/appObjectService";
    export default {
        name: 'AppObjectDetail',
        components: {
            DxButton, DxTextBox, DxTextArea, DxTabPanel, DxItem, DxDataGrid, DxColumn, DxEditing, DxSearchPanel, DxCheckBox
        },
        props: {
            objId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        data() {
            return {
                isSaving: false,
                tx: {
                    TabBasicData: this.$LanguageProvider.GetResource("TabBasicData", "Header", "Basisdaten"),
                    TabRights: this.$LanguageProvider.GetResource("TabRights", "Header", "Berechtigungen"),
                    FieldName: this.$LanguageProvider.GetResource("FieldName", "Caption", "Name"),
                    FieldDesc: this.$LanguageProvider.GetResource("FieldDesc", "Caption", "Beschreibung"),
                    FieldAlias: this.$LanguageProvider.GetResource("FieldAlias", "Caption", "Alias"),
                    FieldVisible: this.$LanguageProvider.GetResource("FieldVisible", "Caption", "Sichtbar"),
                },
                column: {
                    ColRead: this.$LanguageProvider.GetResource("ColRead", "Caption", "Lesen"),
                    ColCreate: this.$LanguageProvider.GetResource("ColCreate", "Caption", "Anlegen"),
                    ColDelete: this.$LanguageProvider.GetResource("ColDelete", "Caption", "Löschen"),
                    ColEdit: this.$LanguageProvider.GetResource("ColEdit", "Caption", "Bearbeiten"),
                    ColInineEdit: this.$LanguageProvider.GetResource("ColInineEdit", "Caption", "Inline-Bearbeiten"),
                    ColAccObj: this.$LanguageProvider.GetResource("ColAccObj", "Caption", "Berechtigungsobjekt"),
                },
                btn: {
                    BtnCancel: this.$LanguageProvider.GetResource("BtnCancel", "Caption", "Abbrechen"),
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Speichern"),
                    BtnDelete: this.$LanguageProvider.GetResource("BtnDelete", "Caption", "Löschen"),
                }
            };
        },
        computed: {
            appObjectDetail() {
                return this.$store.state.appObjectStore.appObjectDetail
            },
            appObjectDetailIsLoading() {
                return this.$store.state.appObjectStore.appObjectDetailIsLoading
            },
            appObjectDetailText() {
                return JSON.stringify(this.$store.state.appObjectStore.appObjectDetail)
            },
            accessList() {
                return this.$store.state.appObjectStore.accessList
            },
            accessListIsLoading() {
                return this.$store.state.appObjectStore.accessListIsLoading
            },
            accessListText() {
                return JSON.stringify(this.$store.state.appObjectStore.accessList)
            },
            saveButtonType() {
                return this.changed ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed ? false : true
            },
            changed() {
                return this.$store.state.appObjectStore.appObjectDetailChanged
                    || this.$store.state.appObjectStore.accessListChanged
            },
        },
        created: function () {
            let vm = this
            this.$store.dispatch("getAppObjectDetail", { objId: vm.objId })
            this.$store.dispatch("getAccessListForObject", { objId: vm.objId })
        },
        watch: {
            appObjectDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && !this.appObjectDetailIsLoading && oldVal != newVal) {
                    this.$store.state.appObjectStore.appObjectDetailChanged = true
                }
            },
            accessListText: function (newVal, oldVal) {
                if (oldVal != "[]" && !this.accessListIsLoading && oldVal != newVal) {
                    this.$store.state.appObjectStore.accessListChanged = true
                }
            },
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveAppObjectDetail")
                this.$store.dispatch("saveAccessListForObject")
            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.appObjectDetail))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });


            },
        }
    }


</script>
<style>
</style>
